import { guards } from '@/guards'
import { router } from '.'
const customersManagementRoutes = [
    {
        path:'/customers',
        name: 'Customers',
        component:()=>import('../views/dashboard/CustomerManagement/Customers'),
        beforeEnter: () => guards.isAdministrator() ||  guards.isRequester() || router.push({ name: 'Unauthorized' }),
    },
    {
        path:'/create-customer',
        name: 'CreateCustomer',
        component:()=>import('../views/dashboard/CustomerManagement/CreateCustomer'),
        beforeEnter: () => guards.isAdministrator() ||  guards.isRequester() || router.push({ name: 'Unauthorized' }),
       
    },
    {
        path:'/edit-customer/:id',
        name: 'EditCustomer',
        component:()=>import('../views/dashboard/CustomerManagement/EditCustomer'),
        beforeEnter: () => guards.isAdministrator() ||  guards.isRequester() || router.push({ name: 'Unauthorized' }),
        props: true
       
    },
    {
        path:'/customer-details/:id',
        name: 'CustomerDetails',
        component:()=>import('../views/dashboard/CustomerManagement/CustomerDetails'),
        // Sales clerks can view a customer's balance/sales/payments here too —
        // the component itself hides editing and the projects section for them.
        beforeEnter: () => guards.isAdministrator() ||  guards.isRequester() || guards.isSalesClerk() || router.push({ name: 'Unauthorized' }),
        props: true
    },
    {
        path:'/debtors',
        name: 'Debtors',
        component:()=>import('../views/dashboard/CustomerManagement/Debtors'),
        beforeEnter: () => guards.isAdministrator() ||  guards.isRequester() || guards.isExecutive() || guards.isSalesClerk() || router.push({ name: 'Unauthorized' }),
    }

    // ADMIN ROLE
]
export { customersManagementRoutes }
